const t = "Voltooide stap", o = "Terug naar {buttonName}", n = "Door naar {buttonName}", e = {
  completedStep: t,
  backButton: o,
  nextButton: n
};
export {
  o as backButton,
  t as completedStep,
  e as default,
  n as nextButton
};
